import { Flex } from "@chakra-ui/react";
import {
	NewOrderEarprintShippingType,
	useNewOrderStore,
} from "../../../stores/order.store";
import PageTitle from "../../../components/PageTitle";
import { CardSelectable } from "./CardSelectable";
import { OrdersNewPageBaseLayout } from "./OrdersNewPageBaseLayout";
import { OrdersNewPageBaseLayoutButton } from "./OrdersNewPageBaseLayoutButton";

export const ChooseEarprintShippingTypeLayout = () => {
	const { earprintShippingType, setEarprintShippingType } = useNewOrderStore();
	return (
		<OrdersNewPageBaseLayout>
			<Flex direction="column" gap={12} alignItems="center">
				<PageTitle>Sélectionner le mode d'envoi d'empreintes</PageTitle>

				<Flex direction="column" gap={4}>
					<CardSelectable
						w="40rem"
						title="Otoscan"
						subtitle="+1,50€/embout"
						inline
						activated={
							earprintShippingType ===
							NewOrderEarprintShippingType.NATUS_OTOSCAN
						}
						onClick={() =>
							setEarprintShippingType(
								NewOrderEarprintShippingType.NATUS_OTOSCAN,
							)
						}
					/>
					<CardSelectable
						w="40rem"
						title="Empreintes numériques"
						inline
						activated={
							earprintShippingType === NewOrderEarprintShippingType.DIGITAL
						}
						onClick={() =>
							setEarprintShippingType(NewOrderEarprintShippingType.DIGITAL)
						}
					/>
					<CardSelectable
						w="40rem"
						title="Empreintes physiques"
						inline
						activated={
							earprintShippingType === NewOrderEarprintShippingType.PHYSICAL
						}
						onClick={() =>
							setEarprintShippingType(NewOrderEarprintShippingType.PHYSICAL)
						}
					/>
				</Flex>

				<OrdersNewPageBaseLayoutButton />
			</Flex>
		</OrdersNewPageBaseLayout>
	);
};
